/* eslint-disable no-underscore-dangle */
import Trial from '@/services/Trial';

export const insertScript = (src: string) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

export const loadScriptsIfInTrial = async () => {
  if (!(await Trial.isInTrial(window.POCKET.profile()?.email || null))) return;

  const _window: any = window;
  _window.hj = {};
  _window._hjSettings = { hjid: 2890442, hjsv: 6 };

  insertScript(
    `https://www.googleoptimize.com/optimize.js?id=${process.env.VUE_APP_OPTIMIZE_TOKEN}`,
  );
  insertScript(
    `https://static.hotjar.com/c/hotjar-${_window._hjSettings.hjid}.js?sv=${_window._hjSettings.hjsv}`,
  );
};
